//Built-in libraries

import { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastSelector } from "../../../store";
import { clearToast } from "../../../store/Toast";
import { toastMessageType } from "./SnackbarConstant";
import SnackbarSuccess from "./SnackbarSuccess";
import SnackbarFailed from "./SnackbarFailed";
import SnackbarInfo from "./SnackbarInfo";
import SnackbarWarning from "./SnackbarWarning";

//Third party libraries

//Custom components

//Services

//Assets andd Miscellaneous

//Component Begin
const Snackbar = forwardRef((props, ref: any) => {
  const dispatch = useDispatch();
  const { showToast, toastMessage, toastType } = useSelector(toastSelector);

  useImperativeHandle(ref, () => ({
    closeToast() {
      setTimeout(() => {
        dispatch(clearToast());
      }, 5000);
    },
  }));

  const closeToastHandler = () => {
    dispatch(clearToast());
  };

  return (
    <>
      <div
        aria-live="assertive"
        className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-4 sm:items-start z-75"
      >
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={showToast}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-x-2 sm:translate-x-0 sm:translate-x-2"
            enterTo="translate-x-0 sm:translate-x-0"
            leave="transform transition ease-in"
            leaveFrom="translate-x-0 sm:translate-x-0"
            leaveTo="translate-x-2 sm:translate-x-0 sm:translate-x-2"
          >
            <div className="max-w-sm w-full shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              {toastType === toastMessageType.SUCCESS && (
                <SnackbarSuccess
                  message={toastMessage}
                  toastHandler={closeToastHandler}
                />
              )}
              {toastType === toastMessageType.FAILED && (
                <SnackbarFailed
                  message={toastMessage}
                  toastHandler={closeToastHandler}
                />
              )}
              {toastType === toastMessageType.INFO && (
                <SnackbarInfo
                  message={toastMessage}
                  toastHandler={closeToastHandler}
                />
              )}
              {toastType === toastMessageType.WARNING && (
                <SnackbarWarning
                  message={toastMessage}
                  toastHandler={closeToastHandler}
                />
              )}
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
});

export default Snackbar;
